import { css } from '@emotion/react';
import Divider from '@polestar/component-warehouse-react/components/divider/Divider';
import Section from '@polestar/component-warehouse-react/components/section/Section';
import { responsiveStyles } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
import styled from '@emotion/styled';
import Sizes from '@polestar/component-warehouse-react/tokens/sizes/Sizes';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import React, { forwardRef } from 'react';
const SectionSpacer = forwardRef(({ 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
children, size = Sizes.medium, divider = false, ...props }, ref) => {
    if (!divider) {
        return React.createElement(SectionSpacing, { ref: ref, size: size, ...props });
    }
    return (React.createElement(Container, { ref: ref, ...props },
        React.createElement(SectionSpacing, { size: size }),
        React.createElement(StyledDivider, { spacing: Spacings.none }),
        React.createElement(SectionSpacing, { size: size })));
});
SectionSpacer.displayName = 'SectionSpacer';
export default SectionSpacer;
const Container = styled(Section) `
  width: 100%;
`;
const SectionSpacing = styled.div(({ theme, size }) => css `
    ${size &&
    responsiveStyles({
        height: theme.sectionSpacer[size],
        minHeight: theme.sectionSpacer[size],
    })}
  `);
const StyledDivider = styled(Divider) `
  &:after {
    height: 2px;
    opacity: 1;
  }
`;
